const fr: Record<string, string> = {
  'features.todo.empty': "Aucune tâche pour l'instant. Ajoutez-en une ci-dessous.",
  'features.todo.add': 'Ajouter',
  'features.todo.addPlaceholder': 'Nouvelle tâche...',
  'features.todo.noNote': "Aucune note pour l'instant.",
  'features.todo.showArchived': '{{count}} élément(s) archivé(s)',
  'features.todo.hideArchived': 'Masquer les éléments archivés',
  'features.todo.dueDate': "Date d'échéance",
  'features.todo.configure': 'Étiquettes',
  'features.todo.doneConfiguring': 'Terminer la configuration',

  'features.kanban.empty': "Aucune carte pour l'instant.",
  'features.kanban.addCard': 'Ajouter',
  'features.kanban.addCardPlaceholder': 'Titre de la carte...',
  'features.kanban.addColumn': 'Ajouter une colonne',
  'features.kanban.column': 'Colonne',
  'features.kanban.addColumnPlaceholder': 'Nom de la colonne...',
  'features.kanban.noDocument': "Aucune note pour l'instant.",
  'features.kanban.deleteColumn': 'Supprimer la colonne',
  'features.kanban.maxColumns': 'Maximum de 4 colonnes atteint.',
  'features.kanban.notes': 'Notes',
  'features.kanban.archiveCardTitle': 'Archiver cette carte ?',
  'features.kanban.archiveCardMessage':
    "Archiver \"{{title}}\" ? Elle n'apparaîtra plus sur le tableau.",
  'features.kanban.deleteColumnMessage':
    'Supprimer la colonne "{{name}}" ? Toutes les cartes de cette colonne seront perdues.',
  'features.kanban.configureColumns': 'Colonnes',
  'features.kanban.saveColumns': 'Enregistrer la disposition',
  'features.kanban.clickToRename': 'Cliquer pour renommer',
  'features.kanban.showArchived': 'Afficher les archivées',
  'features.kanban.hideArchived': 'Masquer les archivées',
  'features.kanban.restore': 'Restaurer',
  'features.kanban.archived': 'Archivée',
  'features.kanban.moveToTop': 'Déplacer en haut',
  'features.kanban.moveToBottom': 'Déplacer en bas',
  'features.kanban.size': "Points d'effort",
  'features.kanban.setSize': "Définir les points d'effort",
  'features.kanban.filterBy': 'Filtrer :',
  'features.kanban.filterAll': 'Tout',
  'features.kanban.manageLabels': 'Étiquettes',
  'features.kanban.noLabels': 'Aucune étiquette.',
  'features.kanban.addLabel': 'Ajouter',
  'features.kanban.newLabelPlaceholder': "Nom de l'étiquette...",
  'features.kanban.assignee': 'Responsable',
  'features.kanban.noAssignee': 'Aucun responsable',
  'features.kanban.dueDate': "Date d'échéance",
  'features.kanban.hideContent': 'Masquer le contenu',
  'features.kanban.showContent': 'Afficher le contenu',
  'features.tasks.openInPopup': 'Ouvrir en vue complète',
  'features.tasks.reminders': 'Rappels',
  'features.tasks.addReminder': 'Ajouter un rappel',
  'features.tasks.reminderNotification': 'Notification push',
  'features.tasks.reminderMail': 'Email',

  'dashboard.tasks.empty': 'Aucune tâche à venir qui vous est assignée.',
  'dashboard.tasks.openSource': 'Ouvrir dans le projet',
  'dashboard.tasks.todoStatus': 'À faire',
  'dashboard.tasks.markDone': 'Marquer comme fait',
  'dashboard.tasks.markDoneConfirm': 'Marquer "{{title}}" comme fait ?',
};

export default fr;
